import { Injectable } from '@angular/core';
import { DwAction, DwActionType, DwActionItemRequirement, DwActionHandler, DwModalService, 
    DwActionResult, DwActionState, DwModalConfig, DwModalButtonStandardConfigs, DwModalSize, DwGridActionResult, 
    DwFormEventService,
    DwGridActionConfig } from '@devwareapps/devware-cap';
import { PermitRequestEntity } from 'src/app/meta-data/app-meta-data.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PermitRequestModalComponent } from '../components/permit-request-modal/permit-request-modal.component';
import { PermitsMetaDataItemNames } from '../meta-data/permits-meta-data.service'


@DwAction<DwGridActionConfig>({
  keyName: 'permitRequestPending',
  display: 'Create Permit Application Entry',
  actionType: DwActionType.gridAction,
  isGlobal: true,
  parentItemName: PermitsMetaDataItemNames.Permit,
  allowOnce: true,
  defaultMenuConfig: {
      useParentDisplay: false,
      menuDisplay: 'CreatePermitApplication',
      itemRequirement: DwActionItemRequirement.none,
  }, 
  defaultButtonConfig: {
    buttonClass: 'btn-sm btn-success mr-1 mt-1',
    buttonText: 'Add Permit'
  },
  defaultSecurityConfig: {
    requireCanUpdate: true
  },
  
  configData: {
      refreshFullGrid: true,
      includeAllAttributes: true
  }
})

@Injectable()
export class PermitRequestActionService implements DwActionHandler {

  constructor(
    private dwModalService: DwModalService,
    private dwFormEventService: DwFormEventService 
  ) { }

  handleAction(actionState: DwActionState<any>): Observable<DwActionResult> {
    return this.showPendingPermitsModal([]);
  }


  showPendingPermitsModal(data: any[]): Observable<DwActionResult>{
    let modalConfig = new DwModalConfig();

    modalConfig.data = this.dwFormEventService.getFormDataValue<PermitRequestEntity>(PermitsMetaDataItemNames.PermitRequest);
    modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose;
    modalConfig.buttons[0].buttonText = 'Add Permit';
    modalConfig.buttons[0].hidden = true;

    modalConfig.allowFullScreen = false;
    modalConfig.component = PermitRequestModalComponent;
    modalConfig.modalSize = DwModalSize.responsive;
    modalConfig.title = `Add Permit`;

    window.scroll(0,0);

    let result = new DwGridActionResult();
    result.success = true;

    return this.dwModalService.showModal(modalConfig) 
      .pipe(map(modalResult => {
        
        const result = new DwGridActionResult();
        result.success = true;

        if(!modalResult.cancelled){
            result.refreshData = true;             
        }
        return result;
      }));
  }
}
